export const QuizData = [
    {
        id: 0,
        question: "What is the capital of Pakistan?",
        options : ["Karachi", "Lahore", "Islamabad"],
        answer: "Islamabad"
    },
    {
        id: 1,
        question: "Who is founder of Pakistan?",
        options : ["Allama Iqbal", "Muhammad Ali Jinnah", "Liaquat Ali Khan"],
        answer: "Muhammad Ali Jinnah"
    },
    {
        id: 2,
        question: "Who is the current prime Minister of Pakistan?",
        options : ["Nawaz Shareef", "Imran Khan", "Asif Ali Zardari"],
        answer: "Imran Khan"
    },
    {
        id: 3,
        question: "What is the National game of Pakistan?",
        options : ["Hockey", "Cricket", "Football"],
        answer: "Hockey"
    },
    {
        id: 4,
        question: "In which year Pakistan won the cricket world cup ",
        options : ["1990", "2000", "1992"],
        answer: "1992"
    }
]